import React from "react";

export const Rocket = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66602 8.4716L10.102 5.03555C11.0394 4.09817 11.5081 3.62947 12.0253 3.25197C13.0866 2.47743 14.3175 1.96757 15.6156 1.76483C16.2483 1.66602 16.9112 1.66602 18.2368 1.66602C18.3061 1.66602 18.3327 1.69778 18.3327 1.76188C18.3327 3.08755 18.3327 3.75039 18.2338 4.38307C18.0311 5.68117 17.5213 6.91207 16.7468 7.97333C16.3693 8.4906 15.9005 8.95927 14.9632 9.89668L11.5271 13.3327"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.61685 6.748C7.19775 6.748 5.41417 6.44739 4.08627 6.99742C3.11327 7.40045 2.3973 8.33368 1.66602 9.06493L4.42099 10.2456C5.15108 10.5585 4.70477 11.4798 4.58391 12.0842C4.44922 12.7576 4.45673 12.7824 4.94233 13.268L6.73067 15.0563C7.21627 15.5419 7.24108 15.5495 7.91448 15.4148C8.51885 15.2939 9.44018 14.8476 9.75302 15.5777L10.9338 18.3327C11.665 17.6014 12.5983 16.8854 13.0013 15.9124C13.5513 14.5845 13.2507 12.8009 13.2507 11.3818"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7453 5.13928C15.9894 4.89521 15.9894 4.49948 15.7453 4.2554C15.5012 4.01133 15.1054 4.01133 14.8614 4.2554L15.7453 5.13928ZM13.3084 5.80843C13.0643 6.05251 13.0643 6.44824 13.3084 6.69232C13.5524 6.93639 13.9481 6.93639 14.1922 6.69232L13.3084 5.80843ZM14.8614 4.2554L13.3084 5.80843L14.1922 6.69232L15.7453 5.13928L14.8614 4.2554ZM11.6484 3.95843C13.1353 4.00253 14.1925 4.45197 14.8897 5.16639C15.5891 5.88324 16.0004 6.9432 16.0422 8.35221L17.2917 8.31518C17.2434 6.68553 16.7598 5.2931 15.7844 4.29343C14.8065 3.29133 13.4089 2.7601 11.6854 2.70898L11.6484 3.95843Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99935 16.666L9.16602 17.4993"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33333 10L2.5 10.8333"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const User = ({ width = 24, height = 24, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5901 22C20.5901 18.13 16.7402 15 12.0002 15C7.26015 15 3.41016 18.13 3.41016 22"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Delivery = ({
  width = 18,
  height = 18,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00031 10.5H9.75031C10.5753 10.5 11.2503 9.825 11.2503 9V1.5H4.50031C3.37531 1.5 2.39281 2.12249 1.88281 3.03749"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 12.75C1.5 13.995 2.505 15 3.75 15H4.5C4.5 14.175 5.175 13.5 6 13.5C6.825 13.5 7.5 14.175 7.5 15H10.5C10.5 14.175 11.175 13.5 12 13.5C12.825 13.5 13.5 14.175 13.5 15H14.25C15.495 15 16.5 13.995 16.5 12.75V10.5H14.25C13.8375 10.5 13.5 10.1625 13.5 9.75V7.5C13.5 7.0875 13.8375 6.75 14.25 6.75H15.2175L13.935 4.50751C13.665 4.04251 13.17 3.75 12.63 3.75H11.25V9C11.25 9.825 10.575 10.5 9.75 10.5H9"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 16.5C6.82843 16.5 7.5 15.8284 7.5 15C7.5 14.1716 6.82843 13.5 6 13.5C5.17157 13.5 4.5 14.1716 4.5 15C4.5 15.8284 5.17157 16.5 6 16.5Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16.5C12.8284 16.5 13.5 15.8284 13.5 15C13.5 14.1716 12.8284 13.5 12 13.5C11.1716 13.5 10.5 14.1716 10.5 15C10.5 15.8284 11.1716 16.5 12 16.5Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 9V10.5H14.25C13.8375 10.5 13.5 10.1625 13.5 9.75V7.5C13.5 7.0875 13.8375 6.75 14.25 6.75H15.2175L16.5 9Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 6H6"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 8.25H4.5"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 10.5H3"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Shop = ({ width = 18, height = 18, className, ...restProps }) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25781 8.41504V11.7825C2.25781 15.15 3.60781 16.5 6.97531 16.5H11.0178C14.3853 16.5 15.7353 15.15 15.7353 11.7825V8.41504"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00036 9C10.3729 9 11.3854 7.8825 11.2504 6.51L10.7554 1.5H7.25286L6.75036 6.51C6.61536 7.8825 7.62786 9 9.00036 9Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7341 9C15.2491 9 16.3591 7.77 16.2091 6.2625L15.9991 4.2C15.7291 2.25 14.9791 1.5 13.0141 1.5H10.7266L11.2516 6.7575C11.3791 7.995 12.4966 9 13.7341 9Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.23077 9C5.46827 9 6.58577 7.995 6.70577 6.7575L6.87077 5.1L7.23077 1.5H4.94327C2.97827 1.5 2.22827 2.25 1.95827 4.2L1.75577 6.2625C1.60577 7.77 2.71577 9 4.23077 9Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 12.75C7.7475 12.75 7.125 13.3725 7.125 14.625V16.5H10.875V14.625C10.875 13.3725 10.2525 12.75 9 12.75Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Reserve = ({
  width = 18,
  height = 18,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2266 16.5H3.72656C1.47656 16.5 1.47656 15.4875 1.47656 14.25V13.5C1.47656 13.0875 1.81406 12.75 2.22656 12.75H15.7266C16.1391 12.75 16.4766 13.0875 16.4766 13.5V14.25C16.4766 15.4875 16.4766 16.5 14.2266 16.5Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5406 9.75V12.75H2.45312V9.75C2.45312 6.87 4.48563 4.4625 7.19313 3.885C7.59813 3.795 8.01813 3.75 8.45312 3.75H9.54063C9.97563 3.75 10.4031 3.795 10.8081 3.885C13.5156 4.47 15.5406 6.87 15.5406 9.75Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.875 3.375C10.875 3.555 10.8525 3.72 10.8075 3.885C10.4025 3.795 9.975 3.75 9.54 3.75H8.4525C8.0175 3.75 7.5975 3.795 7.1925 3.885C7.1475 3.72 7.125 3.555 7.125 3.375C7.125 2.34 7.965 1.5 9 1.5C10.035 1.5 10.875 2.34 10.875 3.375Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 8.25H6.75"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ShopAdd = ({
  width = 18,
  height = 18,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7569 8.41504V11.7825C15.7569 15.15 14.4144 16.5001 11.0394 16.5001H6.9969C6.5619 16.5001 6.16438 16.4776 5.79688 16.4251"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.2793 11.6401V8.41504"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.02341 9C10.3959 9 11.4084 7.88254 11.2734 6.51004L10.7709 1.5H7.26839L6.76591 6.51004C6.63091 7.88254 7.65091 9 9.02341 9Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7477 9C15.2627 9 16.3727 7.76998 16.2227 6.26248L16.0127 4.19998C15.7427 2.24998 14.9927 1.5 13.0277 1.5H10.7402L11.2652 6.75751C11.4002 7.99501 12.5102 9 13.7477 9Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25381 9C5.49131 9 6.6088 7.99501 6.7288 6.75751L6.89383 5.10004L7.25381 1.5H4.96632C3.00132 1.5 2.25133 2.24998 1.98133 4.19998L1.77131 6.26248C1.62131 7.76998 2.73881 9 4.25381 9Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 14.25C6.75 14.8125 6.59249 15.345 6.31499 15.795C6.17249 16.035 5.99999 16.2525 5.79749 16.425C5.77499 16.455 5.7525 16.4775 5.7225 16.5C5.1975 16.9725 4.5075 17.25 3.75 17.25C2.835 17.25 2.01748 16.8375 1.47748 16.1925C1.46248 16.17 1.44002 16.155 1.42502 16.1325C1.33502 16.0275 1.25251 15.915 1.18501 15.795C0.907513 15.345 0.75 14.8125 0.75 14.25C0.75 13.305 1.185 12.4575 1.875 11.91C2.0025 11.805 2.13748 11.715 2.27998 11.64C2.71498 11.3925 3.2175 11.25 3.75 11.25C4.5 11.25 5.17498 11.52 5.69998 11.9775C5.78998 12.045 5.87249 12.1275 5.94749 12.21C6.44249 12.75 6.75 13.4625 6.75 14.25Z"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8678 14.2344H2.63281"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 13.1396V15.3821"
        stroke="currentColor"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Note = ({ width = 18, height = 18, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 1.5V3.75"
        stroke="#131A22"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.5V3.75"
        stroke="#131A22"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.75 6.375V10.2225C15.0825 9.69 14.235 9.375 13.3125 9.375C12.39 9.375 11.5275 9.69748 10.8525 10.245C9.945 10.9575 9.375 12.075 9.375 13.3125C9.375 14.0475 9.58501 14.7525 9.94501 15.3375C10.2225 15.795 10.5825 16.1925 11.01 16.5H6C3.375 16.5 2.25 15 2.25 12.75V6.375C2.25 4.125 3.375 2.625 6 2.625H12C14.625 2.625 15.75 4.125 15.75 6.375Z"
        stroke="#131A22"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 8.25H9.75"
        stroke="#131A22"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 12H7.215"
        stroke="#131A22"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.25 13.3125C17.25 14.0475 17.04 14.7525 16.68 15.3375C16.47 15.6975 16.2075 16.0125 15.9 16.2675C15.21 16.8825 14.31 17.25 13.3125 17.25C12.45 17.25 11.655 16.9725 11.01 16.5C10.5825 16.1925 10.2225 15.795 9.94501 15.3375C9.58501 14.7525 9.375 14.0475 9.375 13.3125C9.375 12.075 9.945 10.9575 10.8525 10.245C11.5275 9.69748 12.39 9.375 13.3125 9.375C14.235 9.375 15.0825 9.69 15.75 10.2225C16.665 10.9425 17.25 12.06 17.25 13.3125Z"
        stroke="#131A22"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3125 15.1875C13.3125 14.1525 14.1525 13.3125 15.1875 13.3125C14.1525 13.3125 13.3125 12.4725 13.3125 11.4375C13.3125 12.4725 12.4725 13.3125 11.4375 13.3125C12.4725 13.3125 13.3125 14.1525 13.3125 15.1875Z"
        stroke="#131A22"
        strokeOpacity={0.5}
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Rocket2 = ({ width = 18, height = 18, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <g clipPath="url(#clip0_968_12168)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.68667 15.5262C3.33342 16.2608 3.1101 16.7508 1.14304 16.8222C1.19929 14.9243 1.56154 14.7207 2.28548 14.3596C2.58923 14.2077 2.96779 14.0193 3.37729 13.7048L2.69216 12.8302C2.36873 13.0788 2.07117 13.2093 1.78373 13.3522C0.577165 13.954 0.00847756 14.5463 0.00847756 17.3712L0.0180401 17.9461L0.570978 17.9337C3.55279 17.9337 4.11023 17.2598 4.66879 16.1C4.79085 15.8457 4.85891 15.6736 5.06535 15.331L4.23116 14.5733C3.98141 14.9148 3.82504 15.2388 3.68667 15.5251V15.5262ZM12.3925 3.3166C11.1482 3.3166 10.1363 4.32854 10.1363 5.57222C10.1363 6.81591 11.1488 7.82841 12.3925 7.82841C13.6362 7.82841 14.6487 6.81591 14.6487 5.57222C14.6487 4.32854 13.6362 3.3166 12.3925 3.3166ZM12.3925 6.69891C11.7715 6.69891 11.2658 6.19322 11.2658 5.57278C11.2658 4.95235 11.7709 4.44666 12.3925 4.44666C13.014 4.44666 13.5192 4.95235 13.5192 5.57278C13.5192 6.19379 13.014 6.69891 12.3925 6.69891ZM17.9967 0.515348C17.9798 0.23466 17.757 0.00966009 17.4764 -0.0111524C17.4764 -0.0111524 14.3286 -0.240652 11.3001 0.890535C10.1937 1.30397 9.28298 1.95816 8.43304 2.94985C7.72429 3.77672 7.02004 5.27072 6.39848 6.5116C6.15829 6.99029 5.92879 7.44872 5.73416 7.7986H2.60498C2.4441 7.7986 2.2911 7.86778 2.18423 7.9876L0.122103 10.2224C-0.00952244 10.3715 -0.0533974 10.5785 0.00735256 10.7675C0.0681026 10.9565 0.223915 11.1005 0.417415 11.1443L3.77385 11.9116C4.00279 12.194 4.3836 12.6164 4.99335 13.2931L6.26516 14.7027L6.94973 17.5985C6.99473 17.7892 7.13592 17.9433 7.32267 18.0035C7.37948 18.0215 7.43854 18.031 7.49648 18.031C7.62923 18.031 7.75917 17.9843 7.86267 17.8955L9.94673 15.8221C10.071 15.7158 10.143 15.5594 10.143 15.3952V12.4927C10.4232 12.3188 10.9199 12.0505 11.3873 11.789C12.6608 11.0774 14.5626 10.1909 15.3507 9.49004C16.461 8.50341 16.8649 7.78004 17.262 6.71072C18.2059 4.16766 18.0062 0.663285 17.9967 0.515348ZM16.2079 6.31866C15.8614 7.25185 15.5475 7.80985 14.6037 8.64853C13.9067 9.26785 11.9999 10.1572 10.8383 10.8068C9.97148 11.2912 9.45229 11.5741 9.22448 11.7603C9.09342 11.8666 9.01748 12.0269 9.01748 12.1957V15.1358L7.8306 16.4403L7.32491 14.3028C7.30298 14.2111 7.25854 14.1262 7.19498 14.0558C6.16054 12.9095 4.59792 11.1764 4.4781 11.0386C4.39992 10.9435 4.29135 10.876 4.16929 10.8479L1.59248 10.2584L2.85642 8.92247H6.05648C6.25223 8.92247 6.43392 8.82066 6.53573 8.65472C6.78323 8.25197 7.0701 7.67822 7.4031 7.01504C7.96673 5.89116 8.6676 4.40391 9.28635 3.68166C10.0176 2.82891 10.7595 2.29285 11.6927 1.9441C13.7689 1.16841 15.9109 1.08685 16.8902 1.09416C16.9082 2.13141 16.8694 4.5361 16.2074 6.31922L16.2079 6.31866Z"
          fill="currentColor"
          fillOpacity={0.5}
        />
      </g>
      <defs>
        <clipPath id="clip0_968_12168">
          <rect width={18} height={18} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Eye = ({ width = 18, height = 18, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className + " hover:text-green-500 cursor-pointer"}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6845 8.99945C11.6845 10.4845 10.4845 11.6845 8.99945 11.6845C7.51445 11.6845 6.31445 10.4845 6.31445 8.99945C6.31445 7.51445 7.51445 6.31445 8.99945 6.31445C10.4845 6.31445 11.6845 7.51445 11.6845 8.99945Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00086 15.2016C11.6484 15.2016 14.1159 13.6416 15.8334 10.9416C16.5084 9.88406 16.5084 8.10656 15.8334 7.04906C14.1159 4.34906 11.6484 2.78906 9.00086 2.78906C6.35336 2.78906 3.88586 4.34906 2.16836 7.04906C1.49336 8.10656 1.49336 9.88406 2.16836 10.9416C3.88586 13.6416 6.35336 15.2016 9.00086 15.2016Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Search = ({ width = 20, height = 20, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6673 13.5415C8.79083 13.5415 6.45898 11.2097 6.45898 8.33317C6.45898 5.45669 8.79083 3.12484 11.6673 3.12484C14.5438 3.12484 16.8757 5.45669 16.8757 8.33317C16.8757 11.2097 14.5438 13.5415 11.6673 13.5415ZM5.20898 8.33317C5.20898 11.9 8.10048 14.7915 11.6673 14.7915C15.2342 14.7915 18.1257 11.9 18.1257 8.33317C18.1257 4.76633 15.2342 1.87484 11.6673 1.87484C8.10048 1.87484 5.20898 4.76633 5.20898 8.33317Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21538 13.7841C5.9713 13.5401 5.57557 13.5401 5.3315 13.7841L2.05739 17.0582C1.81331 17.3023 1.81331 17.698 2.05739 17.9421C2.30146 18.1862 2.69719 18.1862 2.94127 17.9421L6.21538 14.668C6.45946 14.4239 6.45946 14.0282 6.21538 13.7841Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ArrowRight = ({
  width = 20,
  height = 20,
  className,
  ...reset
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16406 9.9974H15.8307M15.8307 9.9974L9.9974 4.16406M15.8307 9.9974L9.9974 15.8307"
        stroke="#374151"
        strokeWidth={1.67}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowLeft = ({ width = 20, height = 20, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8359 9.9974H4.16927M4.16927 9.9974L10.0026 4.16406M4.16927 9.9974L10.0026 15.8307"
        stroke="#374151"
        strokeWidth={1.67}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowDown = ({ width = 24, height = 24, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.25 9.75L12 14.25L6.75 9.75"
        stroke="#131A22"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Edit = ({ width = 16, height = 16, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} hover:text-blue-500 cursor-pointer`}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33398 1.3335H6.00065C2.66732 1.3335 1.33398 2.66683 1.33398 6.00016V10.0002C1.33398 13.3335 2.66732 14.6668 6.00065 14.6668H10.0007C13.334 14.6668 14.6673 13.3335 14.6673 10.0002V8.66683"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6933 2.01301L5.43992 7.26635C5.23992 7.46635 5.03992 7.85968 4.99992 8.14635L4.71325 10.153C4.60659 10.8797 5.11992 11.3863 5.84659 11.2863L7.85325 10.9997C8.13325 10.9597 8.52659 10.7597 8.73325 10.5597L13.9866 5.30635C14.8933 4.39968 15.3199 3.34635 13.9866 2.01301C12.6533 0.67968 11.5999 1.10635 10.6933 2.01301Z"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.93945 2.7666C10.3861 4.35994 11.6328 5.6066 13.2328 6.05994"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Trash = ({ width = 16, height = 16, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} hover:text-red-500 cursor-pointer`}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66602 3.3135L5.81268 2.44016C5.91935 1.80683 5.99935 1.3335 7.12602 1.3335H8.87268C9.99935 1.3335 10.086 1.8335 10.186 2.44683L10.3327 3.3135"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5669 6.09326L12.1336 12.8066C12.0603 13.8533 12.0003 14.6666 10.1403 14.6666H5.86026C4.00026 14.6666 3.94026 13.8533 3.86693 12.8066L3.43359 6.09326"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.88672 11H9.10672"
            stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.33398 8.3335H9.66732"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadDocument = ({
  width = 11,
  height = 11,
  className,
  ...reset
}) => {
  return (
    <svg
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.05039 7.65117V4.95117L3.15039 5.85117"
        stroke="#1890FF"
        strokeWidth={0.675}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.05078 4.95117L4.95078 5.85117"
        stroke="#1890FF"
        strokeWidth={0.675}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.90039 4.50137V6.75137C9.90039 9.00137 9.00039 9.90137 6.75039 9.90137H4.05039C1.80039 9.90137 0.900391 9.00137 0.900391 6.75137V4.05137C0.900391 1.80137 1.80039 0.901367 4.05039 0.901367H6.30039"
        stroke="#1890FF"
        strokeWidth={0.675}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.90078 4.50137H8.10078C6.75078 4.50137 6.30078 4.05137 6.30078 2.70137V0.901367L9.90078 4.50137Z"
        stroke="#1890FF"
        strokeWidth={0.675}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const More = ({ width = 20, height = 20, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33398 15.8333C8.33398 16.75 9.08398 17.5 10.0007 17.5C10.9173 17.5 11.6673 16.75 11.6673 15.8333C11.6673 14.9167 10.9173 14.1667 10.0007 14.1667C9.08398 14.1667 8.33398 14.9167 8.33398 15.8333Z"
        stroke="#1F1D2B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33398 4.16634C8.33398 5.08301 9.08398 5.83301 10.0007 5.83301C10.9173 5.83301 11.6673 5.08301 11.6673 4.16634C11.6673 3.24967 10.9173 2.49967 10.0007 2.49967C9.08398 2.49967 8.33398 3.24967 8.33398 4.16634Z"
        stroke="#1F1D2B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33398 10.0003C8.33398 10.917 9.08398 11.667 10.0007 11.667C10.9173 11.667 11.6673 10.917 11.6673 10.0003C11.6673 9.08366 10.9173 8.33366 10.0007 8.33366C9.08398 8.33366 8.33398 9.08366 8.33398 10.0003Z"
        stroke="#1F1D2B"
      />
    </svg>
  );
};

export const Calendar = ({ width = 24, height = 24, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2V5"
        stroke="#131A22"
        strokeOpacity={0.8}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2V5"
        stroke="#131A22"
        strokeOpacity={0.8}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 9.08984H20.5"
        stroke="#131A22"
        strokeOpacity={0.8}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
        stroke="#131A22"
        strokeOpacity={0.8}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6937 13.6992H15.7027"
        stroke="#131A22"
        strokeOpacity={0.8}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6937 16.6992H15.7027"
        stroke="#131A22"
        strokeOpacity={0.8}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9945 13.6992H12.0035"
        stroke="#131A22"
        strokeOpacity={0.8}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9945 16.6992H12.0035"
        stroke="#131A22"
        strokeOpacity={0.8}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29529 13.6992H8.30427"
        stroke="#131A22"
        strokeOpacity={0.8}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29529 16.6992H8.30427"
        stroke="#131A22"
        strokeOpacity={0.8}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Facebook = ({ width = 56, height = 56, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
        fill="#4085FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.1312 36.2471H37.4564L38.7214 28.2676H31.1312V22.2344C31.1312 19.9963 33.2721 18.7313 35.3156 18.7313H39.0134V12.1142L32.3964 11.8222C26.0713 11.433 22.5681 16.3958 22.5681 22.3317V28.2676H15.3672V36.247H22.5681V55.4723C24.3258 55.8179 26.142 56.0009 28.0012 56.0009C29.0595 56.0009 30.1035 55.9402 31.1313 55.8258V36.2471H31.1312Z"
        fill="white"
      />
    </svg>
  );
};

export const Whatsapp = ({ width = 56, height = 56, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
        fill="url(#paint0_linear_1377_15228)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7063 19.908C22.6954 19.2786 23.3249 19.7282 23.6845 20.7173L24.5836 23.055C24.5836 23.055 25.213 24.3138 23.5945 25.5727C23.3249 25.7525 23.3248 25.7525 23.4147 26.2021C23.7744 27.2811 25.213 30.5181 29.7987 33.0357C30.2483 33.3054 30.3382 33.3054 30.7878 32.9457C31.1474 32.5861 31.597 32.1366 31.9567 31.7768C32.7659 31.0575 33.2154 30.7878 33.9348 31.3273C34.4743 31.687 35.0138 32.1366 35.5533 32.4962C36.0928 32.9457 36.992 33.4853 36.0928 34.5642L35.2836 35.5533C34.1147 36.992 33.1256 37.0819 31.597 36.7222C25.7525 35.1937 21.4366 31.0576 19.5485 25.2131C18.919 22.9651 19.8181 21.0769 21.7063 19.908ZM28.0004 10.2871C37.8012 10.2871 45.7136 18.1996 45.7136 28.0004C45.7136 37.8012 37.8011 45.7136 28.0004 45.7136C25.3029 45.7136 22.7853 45.1741 20.5374 44.0951L11.0964 45.7136L12.3551 36.3624L12.2652 36.1826C11.0064 33.7548 10.2871 30.9675 10.2871 28.0003C10.2871 18.1996 18.1996 10.2871 28.0004 10.2871ZM16.8509 41.7574L19.3685 41.3078L20.8971 41.0381C23.0551 42.207 25.3929 42.8364 28.0004 42.8364C36.1827 42.8364 42.8364 36.1827 42.8364 28.0004C42.8364 19.8182 36.1827 13.1645 28.0004 13.1645C19.8181 13.1645 13.1645 19.8182 13.1645 28.0004C13.1645 30.9677 14.0636 33.6651 15.5023 36.0029L15.3225 37.3517L14.9628 40.0491L14.6931 42.1171L16.8509 41.7574Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1377_15228"
          x1={28}
          y1={0.00000924544}
          x2={28}
          y2={56.0001}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42EF62" />
          <stop offset={0.9952} stopColor="#19CB3C" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Insta = ({ width = 56, height = 56, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
        fill="url(#paint0_linear_1377_15224)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7646 10.1641H36.2355C41.5267 10.1641 45.879 14.5164 45.879 19.8076V36.1931C45.879 41.4843 41.5267 45.8367 36.2355 45.8367H19.7646C14.4735 45.8367 10.1211 41.4843 10.1211 36.1931V19.8076C10.121 14.5165 14.4735 10.1641 19.7646 10.1641ZM37.6008 16.394C38.7103 16.394 39.6491 17.3327 39.6491 18.4422C39.6491 19.5516 38.7103 20.4904 37.6008 20.4904C36.4061 20.4904 35.5527 19.5517 35.5527 18.4422C35.5527 17.3328 36.4062 16.394 37.6008 16.394ZM27.9574 18.2715H28.0427C33.3339 18.2715 37.7716 22.7092 37.7716 28.0004C37.7716 33.3769 33.3338 37.7292 28.0427 37.7292H27.9574C22.6662 37.7292 18.3138 33.3769 18.3138 28.0004C18.3138 22.7093 22.6662 18.2715 27.9574 18.2715ZM27.9574 21.5998H28.0427C31.5418 21.5998 34.4433 24.5014 34.4433 28.0005C34.4433 31.5847 31.5418 34.4864 28.0427 34.4864H27.9574C24.4584 34.4864 21.5568 31.5848 21.5568 28.0005C21.5568 24.5014 24.4584 21.5998 27.9574 21.5998ZM19.85 13.2364H36.1501C39.8198 13.2364 42.8068 16.2233 42.8068 19.893V36.1079C42.8068 39.7776 39.8198 42.7645 36.1501 42.7645H19.85C16.1803 42.7645 13.1934 39.7776 13.1934 36.1079V19.893C13.1934 16.2233 16.1803 13.2364 19.85 13.2364Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1377_15224"
          x1={4.7206}
          y1={8.32775}
          x2={52.9277}
          y2={49.065}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0496FB" />
          <stop offset={0.1383} stopColor="#3F72FF" />
          <stop offset={0.2795} stopColor="#784AFF" />
          <stop offset={0.4211} stopColor="#B038EE" />
          <stop offset={0.5656} stopColor="#CD40BE" />
          <stop offset={0.7198} stopColor="#FF415A" />
          <stop offset={0.8647} stopColor="#F7941E" />
          <stop offset={0.9442} stopColor="#FFE800" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Messenger = ({ width = 56, height = 56, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 0C43.5273 0 56 12.2182 56 27.2363C56 42.2545 43.5272 54.4727 28 54.4727C24.9455 54.4727 22.0182 53.9636 19.2182 53.0727L14.1273 55.2363C11.2001 56.509 10.0546 55.3636 10.0546 51.8V48.2363C3.94548 43.1454 0 35.6364 0 27.2363C0 12.2182 12.6 0 28 0Z"
        fill="url(#paint0_linear_1377_15190)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9631 34.1087L18.7086 23.7996C19.5995 22.2723 20.4905 20.7451 22.3995 20.3633C23.7995 19.9815 24.9449 20.4905 26.0904 21.3815L32.0722 25.836C33.0904 26.5997 33.345 26.5997 34.3631 25.836L42.1268 20.1087C44.1631 18.4542 45.9449 19.4724 44.545 21.7633L37.1632 33.5997C37.1632 33.5997 35.5086 36.2724 33.2177 36.1451C33.2177 36.1451 31.5632 36.1451 30.4177 35.1269L24.054 30.1633C23.2904 29.6542 22.9086 29.6542 22.0177 30.2906L13.9995 36.3997C11.7085 38.1815 10.3086 36.6542 11.9631 34.1087Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1377_15190"
          x1={5.45814}
          y1={49.8018}
          x2={47.5498}
          y2={7.71031}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0496FB" />
          <stop offset={0.2204} stopColor="#3F72FF" />
          <stop offset={0.4872} stopColor="#784AFF" />
          <stop offset={0.6626} stopColor="#B038EE" />
          <stop offset={0.7685} stopColor="#CD40BE" />
          <stop offset={1} stopColor="#FF5A5A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Yandex = ({ width = 56, height = 56, className, ...rest }) => {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      className={className}
      {...rest}
    >
      <rect width={56} height={56} rx={4} fill="url(#pattern0_1377_15074)" />
      <defs>
        <pattern
          id="pattern0_1377_15074"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use xlinkHref="#image0_1377_15074" transform="scale(0.00208333)" />
        </pattern>
        <image
          id="image0_1377_15074"
          width={480}
          height={480}
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const Talabat = ({ width = 56, height = 56, className, ...reset }) => {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      className={className}
      {...reset}
    >
      <rect width={56} height={56} fill="url(#pattern0_1377_15064)" />
      <defs>
        <pattern
          id="pattern0_1377_15064"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#image0_1377_15064"
            transform="translate(-0.166667 -0.166667) scale(0.00260417)"
          />
        </pattern>
        <image
          id="image0_1377_15064"
          width={512}
          height={512}
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const HandStars = ({
  width = 18,
  height = 18,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <g clipPath="url(#clip0_1372_12215)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.14595 2.52251C8.52594 1.84084 8.71594 1.5 9 1.5C9.28406 1.5 9.47406 1.84084 9.85405 2.52251L9.95236 2.69887C10.0603 2.89258 10.1143 2.98944 10.1985 3.05334C10.2827 3.11725 10.3875 3.14097 10.5972 3.18841L10.7881 3.23161C11.526 3.39857 11.895 3.48205 11.9828 3.76432C12.0706 4.04659 11.819 4.34072 11.316 4.92898L11.1858 5.08117C11.0429 5.24833 10.9714 5.33191 10.9392 5.43531C10.9071 5.53872 10.9179 5.65023 10.9395 5.87327L10.9592 6.07632C11.0352 6.86118 11.0733 7.25361 10.8435 7.42807C10.6136 7.60252 10.2682 7.44346 9.5773 7.12535L9.39855 7.04305C9.20222 6.95265 9.10406 6.90745 9 6.90745C8.89594 6.90745 8.79778 6.95265 8.60145 7.04305L8.4227 7.12535C7.7318 7.44346 7.38635 7.60252 7.15654 7.42807C6.92674 7.25361 6.96476 6.86118 7.04082 6.07632L7.0605 5.87327C7.08211 5.65023 7.09291 5.53872 7.06076 5.43531C7.0286 5.33191 6.95713 5.24833 6.81418 5.08117L6.68403 4.92898C6.18097 4.34072 5.92945 4.04659 6.01723 3.76432C6.10501 3.48205 6.47396 3.39857 7.21186 3.23161L7.40277 3.18841C7.61246 3.14097 7.7173 3.11725 7.80148 3.05334C7.88567 2.98944 7.93966 2.89258 8.04764 2.69887L8.14595 2.52251Z"
          stroke="currentColor"
          strokeWidth={1.125}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.573 5.76126C14.763 5.42042 14.858 5.25 15 5.25C15.142 5.25 15.237 5.42042 15.427 5.76126L15.4762 5.84943C15.5302 5.94629 15.5572 5.99472 15.5993 6.02667C15.6414 6.05862 15.6938 6.07049 15.7986 6.09421L15.8941 6.1158C16.263 6.19928 16.4475 6.24102 16.4914 6.38216C16.5353 6.5233 16.4095 6.67036 16.158 6.96449L16.0929 7.04058C16.0214 7.12417 15.9857 7.16596 15.9696 7.21766C15.9535 7.26936 15.9589 7.32512 15.9698 7.43663L15.9796 7.53816C16.0176 7.93059 16.0366 8.12681 15.9217 8.21403C15.8068 8.30126 15.6341 8.22173 15.2886 8.06268L15.1993 8.02153C15.1011 7.97633 15.052 7.95373 15 7.95373C14.948 7.95373 14.8989 7.97633 14.8007 8.02153L14.7114 8.06268C14.3659 8.22173 14.1932 8.30126 14.0783 8.21403C13.9634 8.12681 13.9824 7.93059 14.0204 7.53816L14.0302 7.43663C14.0411 7.32512 14.0465 7.26936 14.0304 7.21766C14.0143 7.16596 13.9786 7.12417 13.9071 7.04058L13.842 6.96449C13.5905 6.67036 13.4647 6.5233 13.5086 6.38216C13.5525 6.24102 13.737 6.19928 14.1059 6.1158L14.2014 6.09421C14.3062 6.07049 14.3586 6.05862 14.4007 6.02667C14.4428 5.99472 14.4698 5.94629 14.5238 5.84944L14.573 5.76126Z"
          stroke="currentColor"
          strokeWidth={1.125}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.57297 5.76126C2.76297 5.42042 2.85797 5.25 3 5.25C3.14203 5.25 3.23703 5.42042 3.42703 5.76126L3.47618 5.84943C3.53017 5.94629 3.55717 5.99472 3.59926 6.02667C3.64135 6.05862 3.69377 6.07049 3.79862 6.09421L3.89407 6.1158C4.26302 6.19928 4.4475 6.24102 4.49139 6.38216C4.53528 6.5233 4.40951 6.67036 4.15799 6.96449L4.09291 7.04058C4.02144 7.12417 3.9857 7.16596 3.96962 7.21766C3.95354 7.26936 3.95895 7.32512 3.96975 7.43663L3.97959 7.53816C4.01762 7.93059 4.03663 8.12681 3.92173 8.21403C3.80682 8.30126 3.6341 8.22173 3.28865 8.06268L3.19928 8.02153C3.10111 7.97633 3.05203 7.95373 3 7.95373C2.94797 7.95373 2.89889 7.97633 2.80072 8.02153L2.71135 8.06268C2.3659 8.22173 2.19318 8.30126 2.07827 8.21403C1.96337 8.12681 1.98238 7.93059 2.02041 7.53816L2.03025 7.43663C2.04105 7.32512 2.04646 7.26936 2.03038 7.21766C2.0143 7.16596 1.97856 7.12417 1.90709 7.04058L1.84201 6.96449C1.59049 6.67036 1.46472 6.5233 1.50861 6.38216C1.5525 6.24102 1.73698 6.19928 2.10593 6.1158L2.20138 6.09421C2.30623 6.07049 2.35865 6.05862 2.40074 6.02667C2.44283 5.99472 2.46983 5.94629 2.52382 5.84944L2.57297 5.76126Z"
          stroke="currentColor"
          strokeWidth={1.125}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 15.2913H5.44495C6.2031 15.2913 6.9694 15.3703 7.70725 15.5223C9.01243 15.7912 10.3866 15.8238 11.7052 15.6103C12.3553 15.5051 12.9945 15.3442 13.5731 15.0649C14.0954 14.8128 14.7352 14.4575 15.1649 14.0594C15.5941 13.662 16.041 13.0115 16.3582 12.5031C16.6302 12.0671 16.4986 11.5321 16.0684 11.2073C15.5905 10.8464 14.8813 10.8465 14.4035 11.2074L13.0481 12.2313C12.5228 12.6281 11.949 12.9934 11.2654 13.1024C11.1833 13.1155 11.0971 13.1275 11.0073 13.1379M11.0073 13.1379C10.9802 13.141 10.9528 13.144 10.9251 13.1469M11.0073 13.1379C11.1166 13.1145 11.2252 13.047 11.3271 12.9581C11.8095 12.5371 11.84 11.8275 11.4214 11.3573C11.3243 11.2483 11.2107 11.1573 11.0843 11.0819C8.9863 9.83058 5.72206 10.7837 3.75 12.1822M11.0073 13.1379C10.9799 13.1438 10.9525 13.1469 10.9251 13.1469M10.9251 13.1469C10.5326 13.1872 10.0734 13.1976 9.56382 13.1495"
          stroke="currentColor"
          strokeWidth={1.125}
          strokeLinecap="round"
        />
        <rect
          x={1.5}
          y={10.5}
          width={2.25}
          height={6}
          rx={1.125}
          stroke="currentColor"
          strokeWidth={1.125}
        />
      </g>
      <defs>
        <clipPath id="clip0_1372_12215">
          <rect width={18} height={18} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Remove = ({
  width = 32,
  height = 32,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6562 10.3438L10.3425 21.6575"
        stroke="#021019"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6562 21.6582L10.3425 10.3445"
        stroke="#021019"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CustomerSupport = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.166 9.00375C14.166 8.71567 14.166 8.57167 14.2093 8.44333C14.3353 8.07037 14.6675 7.92563 15.0003 7.77407C15.3743 7.60368 15.5613 7.51849 15.7467 7.5035C15.9571 7.48648 16.1678 7.53182 16.3477 7.63274C16.5861 7.76653 16.7523 8.02078 16.9226 8.22752C17.7088 9.18233 18.1018 9.65983 18.2456 10.1863C18.3617 10.6112 18.3617 11.0555 18.2456 11.4803C18.0358 12.2482 17.3731 12.892 16.8825 13.4878C16.6316 13.7926 16.5061 13.945 16.3477 14.0339C16.1678 14.1348 15.9571 14.1802 15.7467 14.1632C15.5613 14.1482 15.3743 14.063 15.0003 13.8926C14.6675 13.741 14.3353 13.5963 14.2093 13.2233C14.166 13.095 14.166 12.951 14.166 12.6629V9.00375Z"
        stroke="#131A22"
        strokeWidth={1.25}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83268 9.00384C5.83268 8.64117 5.8225 8.31518 5.52927 8.06017C5.42262 7.96742 5.28122 7.90301 4.99844 7.77421C4.62436 7.60382 4.43732 7.51863 4.25198 7.50364C3.69594 7.45867 3.39678 7.83818 3.07612 8.22765C2.28997 9.1825 1.8969 9.65992 1.75307 10.1864C1.637 10.6113 1.637 11.0557 1.75307 11.4805C1.96285 12.2484 2.62562 12.8921 3.11619 13.488C3.42542 13.8636 3.72082 14.2063 4.25198 14.1633C4.43732 14.1483 4.62436 14.0631 4.99844 13.8928C5.28122 13.7639 5.42262 13.6995 5.52927 13.6068C5.8225 13.3518 5.83268 13.0258 5.83268 12.6631V9.00384Z"
        stroke="#131A22"
        strokeWidth={1.25}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16602 7.5C4.16602 4.73857 6.77769 2.5 9.99935 2.5C13.221 2.5 15.8327 4.73857 15.8327 7.5"
        stroke="#131A22"
        strokeWidth={1.25}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.834 14.1665V14.8332C15.834 16.3059 14.3416 17.4998 12.5007 17.4998H10.834"
        stroke="#131A22"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Copy = ({ width = 20, height = 20, className, ...restProps }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3327 10.7498V14.2498C13.3327 17.1665 12.166 18.3332 9.24935 18.3332H5.74935C2.83268 18.3332 1.66602 17.1665 1.66602 14.2498V10.7498C1.66602 7.83317 2.83268 6.6665 5.74935 6.6665H9.24935C12.166 6.6665 13.3327 7.83317 13.3327 10.7498Z"
        stroke="#131A22"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3327 5.74984V9.24984C18.3327 12.1665 17.166 13.3332 14.2493 13.3332H13.3327V10.7498C13.3327 7.83317 12.166 6.6665 9.24935 6.6665H6.66602V5.74984C6.66602 2.83317 7.83268 1.6665 10.7493 1.6665H14.2493C17.166 1.6665 18.3327 2.83317 18.3327 5.74984Z"
        stroke="#131A22"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TrashRed = ({
  width = 91,
  height = 91,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 91 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <rect width={91} height={91} rx={45.5} fill="#FBDCDF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.7735 31.1138C61.3523 30.7738 57.931 30.5188 54.4885 30.3275V30.3062L54.021 27.5437C53.7023 25.5887 53.2348 22.6562 48.2623 22.6562H42.6948C37.7435 22.6562 37.276 25.4612 36.936 27.5225L36.4898 30.2425C34.5135 30.37 32.5373 30.4975 30.561 30.6888L26.226 31.1138C25.3335 31.1988 24.696 31.985 24.781 32.8563C24.866 33.7275 25.631 34.365 26.5235 34.28L30.8585 33.855C41.9935 32.75 53.2135 33.175 64.476 34.3013C64.5398 34.3013 64.5823 34.3013 64.646 34.3013C65.4535 34.3013 66.1548 33.685 66.2398 32.8563C66.3035 31.985 65.666 31.1988 64.7735 31.1138Z"
        fill="#E94E5D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.8644 37.2975C60.3544 36.7663 59.6532 36.4688 58.9307 36.4688H32.0707C31.3482 36.4688 30.6257 36.7663 30.1369 37.2975C29.6482 37.8288 29.3719 38.5512 29.4144 39.295L30.7319 61.0975C30.9657 64.3275 31.2632 68.365 38.6794 68.365H52.3219C59.7382 68.365 60.0357 64.3488 60.2694 61.0975L61.5869 39.3163C61.6294 38.5513 61.3532 37.8288 60.8644 37.2975ZM49.0282 57.7188H41.9519C41.0807 57.7188 40.3582 56.9963 40.3582 56.125C40.3582 55.2537 41.0807 54.5312 41.9519 54.5312H49.0282C49.8994 54.5312 50.6219 55.2537 50.6219 56.125C50.6219 56.9963 49.8994 57.7188 49.0282 57.7188ZM50.8132 49.2188H40.1882C39.3169 49.2188 38.5944 48.4963 38.5944 47.625C38.5944 46.7537 39.3169 46.0312 40.1882 46.0312H50.8132C51.6844 46.0312 52.4069 46.7537 52.4069 47.625C52.4069 48.4963 51.6844 49.2188 50.8132 49.2188Z"
        fill="#E94E5D"
      />
    </svg>
  );
};

export const TabletWifi = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3327 15C18.1669 15.5742 17.9153 16.0269 17.5333 16.4017C16.4138 17.5 14.6122 17.5 11.0088 17.5H9.3101C5.70662 17.5 3.90491 17.5 2.78546 16.4017C1.66602 15.3033 1.66602 13.5355 1.66602 10C1.66602 6.46447 1.66602 4.6967 2.78546 3.59835C3.90491 2.5 5.70662 2.5 9.3101 2.5H11.0088C14.6122 2.5 16.4138 2.5 17.5333 3.59835C17.9153 3.97309 18.1669 4.42577 18.3327 4.99999"
        // stroke="currentColor"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1598 13.3333H14.1667M18.3333 9.262C17.267 8.17334 15.7938 7.5 14.1667 7.5C12.5395 7.5 11.0663 8.17334 10 9.262M12.0833 11.3889C12.6165 10.8446 13.3531 10.5079 14.1667 10.5079C14.9802 10.5079 15.7168 10.8446 16.25 11.3889"
        // stroke="currentColor"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.41602 2.91406V17.0807"
        // stroke="currentColor"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Announcement = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46006 3.37969C10.2233 2.55822 11.5637 2.70972 12.1244 3.68083L15.7011 9.87592C16.2618 10.847 15.7228 12.0836 14.6298 12.3339L5.78082 14.3601L3.28082 10.03L9.46006 3.37969Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.57161 13.9996L3.48828 10.3911C3.1431 9.79326 2.37862 9.58842 1.78075 9.93359C1.18288 10.2788 0.978039 11.0433 1.32322 11.6411L3.40655 15.2496C3.75173 15.8474 4.51622 16.0523 5.11408 15.7071C5.71195 15.3619 5.91679 14.5974 5.57161 13.9996Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8323 13.3327L12.6214 16.4316C12.9666 17.0295 12.7618 17.794 12.1639 18.1392C11.566 18.4843 10.8016 18.2795 10.4564 17.6816L8.24509 13.8516"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2428 4.08497L15.5479 2.94661"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9102 6.97266L18.0485 7.27768"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BoundingBox = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00065 3.33594H8.33398M3.33398 8.33594V5.0026M10.0007 5.0026V8.33594M5.00065 10.0026H8.33398M11.6673 10.0026H15.0007M16.6673 11.6693V15.0026M10.0007 11.6693V15.0026M11.6673 16.6693H15.0007"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33268 4.9974C4.25316 4.9974 4.99935 4.2512 4.99935 3.33073C4.99935 2.41025 4.25316 1.66406 3.33268 1.66406C2.41221 1.66406 1.66602 2.41025 1.66602 3.33073C1.66602 4.2512 2.41221 4.9974 3.33268 4.9974Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33268 11.6693C4.25316 11.6693 4.99935 10.9231 4.99935 10.0026C4.99935 9.08213 4.25316 8.33594 3.33268 8.33594C2.41221 8.33594 1.66602 9.08213 1.66602 10.0026C1.66602 10.9231 2.41221 11.6693 3.33268 11.6693Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0007 4.9974C10.9211 4.9974 11.6673 4.2512 11.6673 3.33073C11.6673 2.41025 10.9211 1.66406 10.0007 1.66406C9.08018 1.66406 8.33398 2.41025 8.33398 3.33073C8.33398 4.2512 9.08018 4.9974 10.0007 4.9974Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0007 11.6693C10.9211 11.6693 11.6673 10.9231 11.6673 10.0026C11.6673 9.08213 10.9211 8.33594 10.0007 8.33594C9.08018 8.33594 8.33398 9.08213 8.33398 10.0026C8.33398 10.9231 9.08018 11.6693 10.0007 11.6693Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6667 11.6693C17.5871 11.6693 18.3333 10.9231 18.3333 10.0026C18.3333 9.08213 17.5871 8.33594 16.6667 8.33594C15.7462 8.33594 15 9.08213 15 10.0026C15 10.9231 15.7462 11.6693 16.6667 11.6693Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0007 18.3333C10.9211 18.3333 11.6673 17.5871 11.6673 16.6667C11.6673 15.7462 10.9211 15 10.0007 15C9.08018 15 8.33398 15.7462 8.33398 16.6667C8.33398 17.5871 9.08018 18.3333 10.0007 18.3333Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6667 18.3333C17.5871 18.3333 18.3333 17.5871 18.3333 16.6667C18.3333 15.7462 17.5871 15 16.6667 15C15.7462 15 15 15.7462 15 16.6667C15 17.5871 15.7462 18.3333 16.6667 18.3333Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckList = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16602 5H17.4993"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16602 10H17.4993"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16602 15H17.4993"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 6.16332C2.5 6.16332 3.33333 6.70649 3.75 7.5026C3.75 7.5026 5 4.3776 6.66667 3.33594"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 15.3274C2.5 15.3274 3.33333 15.8706 3.75 16.6667C3.75 16.6667 5 13.5417 6.66667 12.5"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CopyLink = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1309 11.0152C11.2623 11.8838 9.85408 11.8838 8.98541 11.0152C8.11684 10.1466 8.11684 8.73833 8.98541 7.8697L10.9514 5.90375C11.7804 5.07467 13.1012 5.03694 13.975 5.79055M13.7037 3.15146C14.5723 2.28285 15.9806 2.28285 16.8492 3.15146C17.7178 4.02006 17.7178 5.42836 16.8492 6.29696L14.8832 8.26291C14.0542 9.092 12.7335 9.12975 11.8597 8.37608"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 10.8333C17.5 13.976 17.5 15.5474 16.5237 16.5237C15.5474 17.5 13.976 17.5 10.8333 17.5H9.16667C6.02397 17.5 4.45262 17.5 3.47631 16.5237C2.5 15.5474 2.5 13.976 2.5 10.8333V9.16667C2.5 6.02397 2.5 4.45262 3.47631 3.47631C4.45262 2.5 6.02397 2.5 9.16667 2.5"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DashboardBrowsing = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.08398 10.0026C2.08398 6.27065 2.08398 4.40468 3.24335 3.2453C4.40273 2.08594 6.2687 2.08594 10.0007 2.08594C13.7326 2.08594 15.5986 2.08594 16.758 3.2453C17.9173 4.40468 17.9173 6.27065 17.9173 10.0026C17.9173 13.7345 17.9173 15.6005 16.758 16.7599C15.5986 17.9193 13.7326 17.9193 10.0007 17.9193C6.2687 17.9193 4.40273 17.9193 3.24335 16.7599C2.08398 15.6005 2.08398 13.7345 2.08398 10.0026Z"
        stroke="currentColor"
        strokeWidth={1.25}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.08398 7.5H17.9173"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83398 5H5.84184"
        stroke="currentColor"
        strokeWidth={1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16602 5H9.17389"
        stroke="currentColor"
        strokeWidth={1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1673 14.1667C14.1673 11.8655 12.3018 10 10.0007 10C7.69947 10 5.83398 11.8655 5.83398 14.1667"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5887 12.7422L9.41016 13.9207"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const File01 = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.91602 8.33073C2.91602 5.18803 2.91602 3.61669 3.95335 2.64037C4.99067 1.66406 6.66023 1.66406 9.99935 1.66406H10.6433C13.3609 1.66406 14.7198 1.66406 15.6634 2.32893C15.9338 2.51942 16.1738 2.74533 16.3763 2.9998C17.0827 3.88795 17.0827 5.16686 17.0827 7.72467V9.8459C17.0827 12.3152 17.0827 13.5498 16.6919 14.5359C16.0637 16.1212 14.7351 17.3716 13.0507 17.9629C12.003 18.3307 10.6912 18.3307 8.06753 18.3307C6.56831 18.3307 5.8187 18.3307 5.22 18.1206C4.25751 17.7827 3.49831 17.0681 3.13932 16.1623C2.91602 15.5988 2.91602 14.8933 2.91602 13.4822V8.33073Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0833 10C17.0833 11.5341 15.8397 12.7777 14.3056 12.7777C13.7508 12.7777 13.0967 12.6806 12.5572 12.8251C12.0779 12.9535 11.7035 13.3279 11.5751 13.8072C11.4306 14.3467 11.5277 15.0008 11.5277 15.5556C11.5277 17.0897 10.2841 18.3333 8.75 18.3333"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66602 5.83594H12.4993"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66602 9.16406H9.16602"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Frame = ({ width = 20, height = 20, className, ...restProps }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3848 1.99121L15.4717 1.99609C15.6724 2.01637 15.8609 2.10517 16.0049 2.24902C16.1696 2.4137 16.2624 2.63722 16.2627 2.87012V9.55566C16.2624 9.78858 16.1696 10.0121 16.0049 10.1768C15.8403 10.3413 15.6175 10.4342 15.3848 10.4346H13.8555V11.1777H18.5186L18.6484 11.1914C18.7754 11.2171 18.8934 11.2791 18.9863 11.3721C19.1104 11.4963 19.1804 11.6652 19.1807 11.8408V15.5303C19.1805 15.7059 19.1105 15.8748 18.9863 15.999C18.8621 16.1233 18.6933 16.1931 18.5176 16.1934H17.833V16.874C17.833 17.1745 17.7134 17.4632 17.501 17.6758C17.2884 17.8883 16.9998 18.0078 16.6992 18.0078C16.3986 18.0078 16.11 17.8883 15.8975 17.6758C15.685 17.4632 15.5654 17.1745 15.5654 16.874V16.1934H4.43457V16.874C4.43457 17.1746 4.31507 17.4632 4.10254 17.6758C3.88995 17.8884 3.60143 18.0078 3.30078 18.0078C3.00019 18.0078 2.71158 17.8883 2.49902 17.6758C2.28659 17.4632 2.16699 17.1746 2.16699 16.874V16.1934H1.48242C1.30674 16.1931 1.13788 16.1233 1.01367 15.999C0.889511 15.8748 0.819522 15.7059 0.819336 15.5303V11.8408C0.819569 11.6652 0.889477 11.4963 1.01367 11.3721C1.13786 11.2479 1.3068 11.178 1.48242 11.1777H6.14453V10.4346H4.61621C4.3833 10.4343 4.15981 10.3415 3.99512 10.1768C3.83052 10.0121 3.73758 9.7885 3.7373 9.55566V2.87012C3.73762 2.63728 3.83051 2.41369 3.99512 2.24902C4.15972 2.08438 4.3834 1.99162 4.61621 1.99121H15.3848ZM2.86426 16.874C2.86426 16.9897 2.91052 17.1008 2.99219 17.1826C3.07398 17.2644 3.18511 17.3105 3.30078 17.3105C3.41657 17.3105 3.5275 17.2645 3.60938 17.1826C3.69123 17.1007 3.7373 16.9898 3.7373 16.874V16.1934H2.86426V16.874ZM16.2637 16.874C16.2637 16.9898 16.3097 17.1007 16.3916 17.1826C16.4735 17.2645 16.5844 17.3105 16.7002 17.3105C16.8159 17.3105 16.927 17.2644 17.0088 17.1826C17.0904 17.1008 17.1367 16.9896 17.1367 16.874V16.1934H16.2637V16.874ZM10.3486 15.4961H18.4844V11.875H10.3486V15.4961ZM1.5166 15.4961H9.65137V11.875H1.5166V15.4961ZM6.8418 11.1777H13.1582V10.4346H6.8418V11.1777ZM4.61621 2.68848C4.56825 2.68857 4.52229 2.70741 4.48828 2.74121C4.4542 2.77529 4.43463 2.82192 4.43457 2.87012V9.55566C4.43463 9.60379 4.45332 9.6505 4.4873 9.68457C4.52134 9.71865 4.56805 9.73719 4.61621 9.7373H15.3848C15.4327 9.73712 15.4787 9.71844 15.5127 9.68457C15.5468 9.65049 15.5663 9.60386 15.5664 9.55566V2.87012C15.5663 2.82192 15.5468 2.77529 15.5127 2.74121C15.4788 2.70739 15.4327 2.68866 15.3848 2.68848H4.61621Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.15}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.57383 7.93906C8.61371 7.96346 8.65917 7.97725 8.70588 7.97911C8.7526 7.98097 8.79901 7.97084 8.8407 7.94969L11.7762 6.45797C11.8212 6.43509 11.8589 6.40022 11.8853 6.3572C11.9117 6.31417 11.9257 6.26469 11.9257 6.21422C11.9257 6.16374 11.9117 6.11426 11.8853 6.07124C11.8589 6.02822 11.8212 5.99334 11.7762 5.97047L8.8407 4.4789C8.79902 4.45771 8.75259 4.44757 8.70587 4.44944C8.65914 4.45131 8.61368 4.46513 8.57382 4.48958C8.53396 4.51403 8.50103 4.5483 8.47819 4.5891C8.45535 4.62991 8.44336 4.67589 8.44336 4.72265V7.70594C8.44338 7.7527 8.45539 7.79868 8.47823 7.83949C8.50106 7.8803 8.53398 7.91458 8.57383 7.93906ZM8.99023 5.16828L11.0487 6.21422L8.99023 7.26109V5.16828Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.55109 14.4031H6.61641C6.7481 14.403 6.87437 14.3506 6.96745 14.2574C7.06053 14.1643 7.11281 14.0379 7.11281 13.9062V13.4653C7.11269 13.3337 7.06035 13.2075 6.96729 13.1144C6.87423 13.0213 6.74804 12.9689 6.61641 12.9688H4.55109C4.41949 12.9689 4.29332 13.0213 4.20026 13.1143C4.10721 13.2074 4.05485 13.3336 4.05469 13.4652V13.9062C4.05469 14.0379 4.10697 14.1643 4.20005 14.2574C4.29313 14.3506 4.4194 14.403 4.55109 14.4031ZM4.60156 13.5158H6.56594V13.8563H4.60156V13.5158Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4484 12.9688H13.3831C13.2515 12.9689 13.1254 13.0213 13.0323 13.1143C12.9392 13.2074 12.8869 13.3336 12.8867 13.4652V13.9062C12.8868 14.0379 12.9392 14.1641 13.0323 14.2571C13.1253 14.3502 13.2515 14.4025 13.3831 14.4027H15.4484C15.5801 14.4025 15.7062 14.3502 15.7993 14.2571C15.8924 14.1641 15.9447 14.0379 15.9448 13.9062V13.4653C15.9447 13.3337 15.8924 13.2075 15.7993 13.1144C15.7063 13.0213 15.5801 12.9689 15.4484 12.9688ZM15.398 13.8561H13.4336V13.5156H15.398V13.8561Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SaleTag02 = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.584 4.16406C15.2743 4.16406 15.834 4.72371 15.834 5.41406C15.834 6.10442 15.2743 6.66406 14.584 6.66406C13.8936 6.66406 13.334 6.10442 13.334 5.41406C13.334 4.72371 13.8936 4.16406 14.584 4.16406Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.31121 9.28398C1.47525 10.2176 1.45727 11.6262 2.22449 12.6171C3.74694 14.5835 5.4133 16.2498 7.37963 17.7722C8.37052 18.5395 9.7791 18.5215 10.7128 17.6856C13.2476 15.4159 15.5689 13.044 17.8093 10.4373C18.0308 10.1796 18.1693 9.86381 18.2004 9.5254C18.3379 8.02905 18.6204 3.71795 17.4496 2.54718C16.2788 1.3764 11.9677 1.65887 10.4714 1.79636C10.1329 1.82746 9.8171 1.966 9.55935 2.18749C6.95278 4.42778 4.58086 6.74915 2.31121 9.28398Z"
        stroke="currentColor"
        strokeWidth={1.25}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1076 8.77827C12.3519 8.53436 12.3522 8.13864 12.1084 7.89436C11.8644 7.65008 11.4687 7.64976 11.2244 7.89363L12.1076 8.77827ZM6.22444 12.8854C5.98016 13.1293 5.97983 13.525 6.22371 13.7693C6.46759 14.0136 6.86332 14.0139 7.10759 13.77L6.22444 12.8854ZM10.8864 10.1333C10.795 10.4662 10.9909 10.81 11.3238 10.9014C11.6566 10.9927 12.0005 10.7969 12.0919 10.4639L10.8864 10.1333ZM7.35245 11.5369C7.3828 11.193 7.12867 10.8897 6.78482 10.8594C6.44098 10.8289 6.13764 11.0831 6.10729 11.4269L7.35245 11.5369ZM9.67952 10.3178C9.35477 9.99352 9.29802 9.79902 9.29335 9.71294C9.28985 9.64769 9.30977 9.52511 9.51885 9.31644L8.63568 8.43177C8.28793 8.77902 8.0155 9.22736 8.04518 9.78002C8.07376 10.3119 8.37577 10.7824 8.79635 11.2024L9.67952 10.3178ZM9.51885 9.31644C9.82493 9.01086 10.3399 9.00469 10.6688 9.33302L11.5519 8.44836C10.7488 7.64653 9.44327 7.62553 8.63568 8.43177L9.51885 9.31644ZM8.9061 12.4405C8.65843 12.6878 8.4621 12.7239 8.31464 12.7075C8.13862 12.6881 7.9112 12.5786 7.66304 12.3309L6.77988 13.2155C7.14919 13.5842 7.62481 13.889 8.1775 13.95C8.75877 14.0142 9.31685 13.7968 9.78927 13.3251L8.9061 12.4405ZM8.79635 11.2024C9.12635 11.5318 9.2101 11.7479 9.21893 11.8744C9.22593 11.9754 9.19402 12.1531 8.9061 12.4405L9.78927 13.3251C10.2216 12.8935 10.5074 12.3819 10.4659 11.7873C10.4261 11.2182 10.0949 10.7324 9.67952 10.3178L8.79635 11.2024ZM11.5519 9.33302L12.1076 8.77827L11.2244 7.89363L10.6688 8.44836L11.5519 9.33302ZM6.77988 12.3309L6.22444 12.8854L7.10759 13.77L7.66304 13.2155L6.77988 12.3309ZM10.6688 9.33302C10.8901 9.55394 10.9606 9.86244 10.8864 10.1333L12.0919 10.4639C12.2822 9.76994 12.099 8.99452 11.5519 8.44836L10.6688 9.33302ZM7.66304 12.3309C7.42516 12.0934 7.32981 11.7934 7.35245 11.5369L6.10729 11.4269C6.05105 12.0642 6.28859 12.725 6.77988 13.2155L7.66304 12.3309Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Setting01 = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7652 5.94986L17.3539 5.23602C17.0428 4.69617 16.8873 4.42624 16.6226 4.3186C16.358 4.21097 16.0586 4.2959 15.4601 4.46577L14.4432 4.75218C14.0611 4.84032 13.6601 4.79032 13.3111 4.61102L13.0304 4.44905C12.7312 4.25739 12.501 3.97481 12.3736 3.64265L12.0953 2.8115C11.9123 2.26148 11.8208 1.98647 11.603 1.82917C11.3852 1.67187 11.0959 1.67188 10.5172 1.67188H9.58823C9.00965 1.67188 8.72032 1.67187 8.50248 1.82917C8.28469 1.98647 8.1932 2.26148 8.01022 2.8115L7.73192 3.64265C7.60452 3.97481 7.37436 4.25739 7.07513 4.44905L6.79439 4.61102C6.44543 4.79032 6.04447 4.84032 5.6623 4.75218L4.64544 4.46577C4.04682 4.2959 3.74752 4.21097 3.48287 4.3186C3.21822 4.42624 3.06269 4.69617 2.75161 5.23602L2.34029 5.94986C2.0487 6.4559 1.9029 6.70892 1.9312 6.97827C1.95949 7.24762 2.15467 7.46468 2.54503 7.8988L3.40423 8.85937C3.61423 9.1252 3.76332 9.58853 3.76332 10.0051C3.76332 10.4219 3.61428 10.885 3.40426 11.1509L2.54503 12.1115C2.15467 12.5457 1.9595 12.7627 1.9312 13.0321C1.9029 13.3014 2.0487 13.5544 2.34029 14.0604L2.7516 14.7743C3.06267 15.3141 3.21822 15.5841 3.48287 15.6917C3.74752 15.7994 4.04683 15.7144 4.64546 15.5445L5.66227 15.2581C6.04451 15.1699 6.44554 15.22 6.79454 15.3994L7.07523 15.5614C7.37441 15.753 7.60452 16.0355 7.7319 16.3677L8.01022 17.1989C8.1932 17.7489 8.28469 18.0239 8.50248 18.1813C8.72032 18.3385 9.00965 18.3385 9.58823 18.3385H10.5172C11.0959 18.3385 11.3852 18.3385 11.603 18.1813C11.8208 18.0239 11.9123 17.7489 12.0953 17.1989L12.3736 16.3677C12.501 16.0355 12.7311 15.753 13.0303 15.5614L13.311 15.3994C13.66 15.22 14.061 15.1699 14.4432 15.2581L15.4601 15.5445C16.0586 15.7144 16.358 15.7994 16.6226 15.6917C16.8873 15.5841 17.0428 15.3141 17.3539 14.7743L17.7652 14.0604C18.0568 13.5544 18.2026 13.3014 18.1743 13.0321C18.146 12.7627 17.9508 12.5457 17.5605 12.1115L16.7012 11.1509C16.4912 10.885 16.3421 10.4219 16.3421 10.0051C16.3421 9.58853 16.4913 9.1252 16.7012 8.85937L17.5605 7.8988C17.9508 7.46468 18.146 7.24762 18.1743 6.97827C18.2026 6.70892 18.0568 6.4559 17.7652 5.94986Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9329 10.0026C12.9329 11.6134 11.6271 12.9193 10.0163 12.9193C8.40542 12.9193 7.09961 11.6134 7.09961 10.0026C7.09961 8.39177 8.40542 7.08594 10.0163 7.08594C11.6271 7.08594 12.9329 8.39177 12.9329 10.0026Z"
        stroke="currentColor"
        strokeWidth={1.25}
      />
    </svg>
  );
};

export const TruckDelivery = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1667 16.6693C15.0871 16.6693 15.8333 15.9231 15.8333 15.0026C15.8333 14.0821 15.0871 13.3359 14.1667 13.3359C13.2462 13.3359 12.5 14.0821 12.5 15.0026C12.5 15.9231 13.2462 16.6693 14.1667 16.6693Z"
        stroke="currentColor"
        strokeWidth={1.25}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83268 16.6693C6.75316 16.6693 7.49935 15.9231 7.49935 15.0026C7.49935 14.0821 6.75316 13.3359 5.83268 13.3359C4.91221 13.3359 4.16602 14.0821 4.16602 15.0026C4.16602 15.9231 4.91221 16.6693 5.83268 16.6693Z"
        stroke="currentColor"
        strokeWidth={1.25}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16602 14.9796C3.25208 14.9341 2.68193 14.7981 2.27621 14.3924C1.87048 13.9867 1.73453 13.4165 1.68897 12.5026M7.49935 15.0026H12.4993M15.8327 14.9796C16.7466 14.9341 17.3168 14.7981 17.7225 14.3924C18.3327 13.7822 18.3327 12.8001 18.3327 10.8359V9.16927H14.416C13.7956 9.16927 13.4853 9.16927 13.2343 9.08769C12.7269 8.92285 12.3291 8.52502 12.1643 8.01763C12.0827 7.76658 12.0827 7.45636 12.0827 6.83594C12.0827 5.9053 12.0827 5.43998 11.9603 5.0634C11.713 4.3023 11.1163 3.70559 10.3553 3.4583C9.97868 3.33594 9.51335 3.33594 8.58268 3.33594H1.66602"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66602 6.66406H6.66602"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66602 9.16406H4.99935"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.084 5H13.6017C14.8145 5 15.4208 5 15.9143 5.29476C16.4078 5.58952 16.6953 6.12343 17.2703 7.19125L18.334 9.16667"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const User1 = ({ width = 20, height = 20, className, ...restProps }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66602 9.16406C3.6091 7.12892 6.36871 7.03309 8.33268 9.16406M7.07859 3.7474C7.07859 4.89799 6.14452 5.83073 4.99229 5.83073C3.84006 5.83073 2.90599 4.89799 2.90599 3.7474C2.90599 2.5968 3.84006 1.66406 4.99229 1.66406C6.14452 1.66406 7.07859 2.5968 7.07859 3.7474Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.666 18.3359C13.6091 16.3008 16.3687 16.2049 18.3327 18.3359M17.0786 12.9193C17.0786 14.0699 16.1445 15.0026 14.9923 15.0026C13.8401 15.0026 12.906 14.0699 12.906 12.9193C12.906 11.7687 13.8401 10.8359 14.9923 10.8359C16.1445 10.8359 17.0786 11.7687 17.0786 12.9193Z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 11.6641C2.5 14.8891 5.10833 17.4974 8.33333 17.4974L7.5 15.8307"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 2.5H17.5M12.5 5H17.5M12.5 7.5H15.4167"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ShoppingCart = ({
  width = 24,
  height = 24,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2H3.74001C4.82001 2 5.67 2.93 5.58 4L4.75 13.96C4.61 15.59 5.89999 16.99 7.53999 16.99H18.19C19.63 16.99 20.89 15.81 21 14.38L21.54 6.88C21.66 5.22 20.4 3.87 18.73 3.87H5.82001"
        // stroke="#1F1D2B"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.25 22C16.9404 22 17.5 21.4404 17.5 20.75C17.5 20.0596 16.9404 19.5 16.25 19.5C15.5596 19.5 15 20.0596 15 20.75C15 21.4404 15.5596 22 16.25 22Z"
        // stroke="#1F1D2B"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 22C8.94036 22 9.5 21.4404 9.5 20.75C9.5 20.0596 8.94036 19.5 8.25 19.5C7.55964 19.5 7 20.0596 7 20.75C7 21.4404 7.55964 22 8.25 22Z"
        // stroke="#1F1D2B"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 8H21"
        // stroke="#1F1D2B"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const TableManagement = ({
  width = 20,
  height = 20,
  className,
  ...restProps
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      {...restProps}
    >
      <path
        d="M1.54785 8.36328C1.6226 8.35827 1.69937 8.37614 1.76953 8.42188L1.83691 8.47754L2.77441 9.41504C2.84694 9.48757 2.88758 9.5857 2.8877 9.68848V13.0518H6.25098C6.98151 13.0519 7.57496 13.6455 7.5752 14.376V18.4385C7.5752 18.6525 7.40249 18.826 7.18848 18.8262C6.97433 18.8262 6.80078 18.6526 6.80078 18.4385V15.3887H4.06348C3.84933 15.3887 3.67578 15.2151 3.67578 15.001C3.67601 14.787 3.84947 14.6143 4.06348 14.6143H6.80078V14.376C6.80055 14.0732 6.55382 13.8263 6.25098 13.8262H2.8877V18.4404C2.8854 18.5635 2.83768 18.6607 2.7627 18.7266C2.68888 18.7913 2.59321 18.8226 2.5 18.8223C2.4069 18.8219 2.31173 18.7902 2.23828 18.7256C2.16355 18.6597 2.1154 18.5626 2.11328 18.4404V9.84961L1.28906 9.02539C1.2023 8.9376 1.16689 8.8343 1.17383 8.73438C1.18067 8.63643 1.22751 8.54718 1.29395 8.48145C1.3604 8.41571 1.45016 8.36985 1.54785 8.36328Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.15"
      />
      <path
        d="M18.4541 8.35938C18.5522 8.3663 18.6421 8.41389 18.708 8.48047C18.7736 8.54699 18.8196 8.63684 18.8262 8.73438C18.8328 8.83387 18.798 8.93619 18.7119 9.02246L17.8877 9.84668V18.4375C17.8857 18.5609 17.837 18.6587 17.7617 18.7246C17.6878 18.7891 17.5922 18.8198 17.499 18.8193C17.4057 18.8189 17.3098 18.7874 17.2363 18.7227C17.1617 18.6568 17.1139 18.5595 17.1123 18.4375V15.3867H13.2002V18.4375C13.1978 18.5607 13.1493 18.6587 13.0742 18.7246C13.0006 18.7891 12.9054 18.8196 12.8125 18.8193C12.7193 18.819 12.6233 18.7874 12.5498 18.7227C12.4753 18.6568 12.4271 18.5596 12.4248 18.4375V14.374C12.4248 13.6432 13.0192 13.0488 13.75 13.0488H17.1123V9.68652C17.1123 9.58362 17.153 9.48473 17.2256 9.41211L18.1631 8.47461H18.1641C18.2515 8.3877 18.3542 8.35234 18.4541 8.35938ZM13.75 13.8242C13.4469 13.8242 13.2002 14.0709 13.2002 14.374V14.6113H17.1123V13.8242H13.75Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.15"
      />
      <path
        d="M14.999 11.1748C15.2132 11.1748 15.3867 11.3484 15.3867 11.5625C15.3867 11.7766 15.2132 11.9502 14.999 11.9502H10.3867V18.0498H11.251C11.3737 18.0521 11.4712 18.1 11.5371 18.1748C11.6019 18.2484 11.6329 18.3443 11.6328 18.4375C11.6327 18.5305 11.6017 18.6257 11.5371 18.6992C11.4712 18.7741 11.3737 18.8228 11.251 18.8252H8.74902C8.53509 18.8249 8.3623 18.6515 8.3623 18.4375C8.3623 18.2235 8.53509 18.0501 8.74902 18.0498H9.6123V11.9502H4.99805C4.87479 11.9478 4.77686 11.8993 4.71094 11.8242C4.64635 11.7505 4.61581 11.6545 4.61621 11.5615C4.61671 11.4685 4.64821 11.3731 4.71289 11.2998C4.77878 11.2252 4.87594 11.1771 4.99805 11.1748H14.999Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.15"
      />
      <path
        d="M9.56641 1.9502C9.46209 2.32178 9.1904 2.63333 8.8291 2.78223C8.45495 2.93838 8.04783 2.91131 7.70703 2.71875L7.09375 3.33203C7.28572 3.67217 7.31341 4.07785 7.16211 4.44434C7.02177 4.80058 6.70966 5.08426 6.3252 5.19141V6.05859C6.70009 6.16255 7.0062 6.42936 7.15723 6.79492L7.20996 6.94434C7.30456 7.27568 7.26185 7.62147 7.09473 7.91699L7.70703 8.5293C8.3986 8.12386 9.36064 8.51131 9.56738 9.2998H10.4326C10.5325 8.90942 10.8275 8.61444 11.1807 8.46875C11.5334 8.32334 11.9492 8.32454 12.293 8.5293L12.9053 7.91699C12.7088 7.56771 12.6832 7.14379 12.8525 6.77246C12.9938 6.43031 13.3047 6.16133 13.6748 6.05762V5.19238C13.2845 5.09244 12.9895 4.79748 12.8438 4.44434C12.6981 4.09133 12.6989 3.67498 12.9043 3.33105C12.8865 3.31325 12.8634 3.29014 12.8369 3.26367C12.772 3.19878 12.6851 3.11282 12.5986 3.02637C12.5122 2.93992 12.4262 2.85298 12.3613 2.78809C12.3344 2.76113 12.3109 2.73767 12.293 2.71973C11.6016 3.12557 10.6393 2.73884 10.4326 1.9502H9.56641ZM6.28418 7.73535C6.44511 7.54378 6.54618 7.31643 6.44727 7.10449L6.44629 7.10156C6.37581 6.93139 6.2351 6.81966 6.06641 6.79102C5.95774 6.77964 5.83354 6.75958 5.73438 6.70215C5.68301 6.67239 5.63687 6.63229 5.60352 6.57715C5.57009 6.52186 5.55147 6.4559 5.5498 6.37891V4.87305L5.55176 4.87207H5.5498C5.55087 4.7943 5.56958 4.72746 5.60352 4.67188C5.63724 4.61664 5.68376 4.57638 5.73535 4.54688C5.83621 4.48935 5.96268 4.46912 6.06934 4.45801C6.24465 4.42884 6.38943 4.3004 6.4541 4.13086L6.45508 4.12988C6.51227 3.99013 6.49412 3.80885 6.39258 3.66602V3.66504C6.32442 3.58063 6.25102 3.47993 6.22168 3.37012C6.20637 3.31273 6.20234 3.25111 6.21777 3.18848C6.23328 3.12588 6.26712 3.06628 6.32031 3.01074L7.38477 1.94629C7.51826 1.81279 7.72957 1.79405 7.88379 1.9043V1.90527L7.8877 1.90723L7.88574 1.89648L8.04395 2.01855C8.18176 2.12478 8.36601 2.13322 8.52637 2.06641C8.68692 1.9994 8.81066 1.8623 8.83301 1.69336C8.84418 1.58431 8.86433 1.4591 8.92188 1.35938C8.95159 1.30788 8.99262 1.26195 9.04785 1.22852C9.10315 1.1951 9.16905 1.17649 9.24609 1.1748H10.752V1.17676L10.7529 1.1748C10.8307 1.17587 10.8975 1.19458 10.9531 1.22852C11.0084 1.26224 11.0486 1.30876 11.0781 1.36035C11.1349 1.45996 11.1548 1.58462 11.166 1.69043L11.1807 1.75195C11.2172 1.8723 11.2999 1.97543 11.4092 2.03809L11.4658 2.06641L11.4727 2.06934L11.5488 2.09961C11.6263 2.12094 11.7084 2.11665 11.792 2.0918C11.9047 2.05827 12.0161 1.98911 12.1113 1.9082L12.1162 1.9043C12.2707 1.79413 12.4817 1.81276 12.6152 1.94629L12.7812 2.1123C12.881 2.21201 13.0145 2.3446 13.1475 2.47754C13.2804 2.61048 13.413 2.74404 13.5127 2.84375L13.6787 3.00977C13.7332 3.0649 13.7679 3.12507 13.7832 3.18848C13.7984 3.25152 13.7939 3.31346 13.7783 3.37109C13.748 3.48295 13.6726 3.58549 13.6055 3.66797C13.4991 3.80613 13.4916 3.992 13.5586 4.15234C13.6257 4.3126 13.7628 4.43561 13.9316 4.45801H13.9307C14.0399 4.46916 14.1656 4.48916 14.2656 4.54688C14.3171 4.57659 14.3631 4.61761 14.3965 4.67285C14.4299 4.72815 14.4485 4.79404 14.4502 4.87109V6.37695C14.4502 6.56652 14.3129 6.72871 14.126 6.75977L14.1201 6.76074V6.75977C13.8738 6.78024 13.6387 6.87216 13.5596 7.08789L13.5557 7.09766C13.5027 7.19601 13.5 7.30518 13.5332 7.41699C13.5583 7.50149 13.6033 7.58535 13.6582 7.66211L13.7168 7.73633L13.7207 7.74121C13.8167 7.87593 13.8151 8.05435 13.7236 8.18652L13.6787 8.24023L13.5127 8.40625C13.413 8.50596 13.2804 8.63952 13.1475 8.77246C13.0145 8.9054 12.881 9.03799 12.7812 9.1377L12.6152 9.30371L12.6123 9.30273L12.6143 9.30469C12.5586 9.35881 12.4987 9.39288 12.4355 9.4082C12.3727 9.42343 12.3113 9.41892 12.2539 9.40332C12.1425 9.3729 12.0392 9.29856 11.9561 9.23145L11.9023 9.19629C11.7725 9.12438 11.614 9.12512 11.4736 9.18359C11.3131 9.2506 11.1893 9.3877 11.167 9.55664C11.1558 9.66569 11.1357 9.7909 11.0781 9.89062C11.0484 9.94212 11.0074 9.98805 10.9521 10.0215C10.8969 10.0549 10.831 10.0735 10.7539 10.0752H9.24805C9.05848 10.0752 8.89629 9.93791 8.86523 9.75098L8.86426 9.74512V9.74414C8.84115 9.47836 8.74747 9.25573 8.50781 9.1709L8.50488 9.16992C8.3651 9.11297 8.18362 9.13236 8.04102 9.2334L8.04004 9.23242C7.95548 9.30073 7.85495 9.37499 7.74512 9.4043C7.68773 9.4196 7.62609 9.4227 7.56348 9.40723C7.50089 9.39168 7.44129 9.3579 7.38574 9.30469L7.38477 9.30371L6.32129 8.23926C6.1876 8.10528 6.17025 7.89417 6.28027 7.74023L6.2832 7.73535H6.28418Z"
        fill="currentColor"  
        stroke="currentColor"
        strokeWidth="0.15"
      />
      <path
        d="M7.73828 5.62695C7.70795 4.08085 9.35568 2.93773 10.79 3.50781C10.904 3.55388 10.9781 3.63391 11.0127 3.72754C11.0465 3.81934 11.0412 3.9191 11.0078 4.00586C10.9743 4.09281 10.911 4.17128 10.8242 4.2168C10.7359 4.26307 10.6278 4.27328 10.5127 4.23145L10.5107 4.23047C9.57428 3.86078 8.49391 4.61336 8.5127 5.62207C8.58244 7.59316 11.4181 7.59375 11.4883 5.62305V5.61426L11.4893 5.50781C11.485 5.46985 11.4765 5.42921 11.4658 5.38574C11.4552 5.34265 11.4433 5.29917 11.4307 5.25391C11.4182 5.20945 11.4052 5.1636 11.3955 5.11816C11.3764 5.02866 11.3655 4.93061 11.3945 4.83984C11.4252 4.74431 11.4964 4.66808 11.6143 4.61523L11.625 4.61035L11.6445 4.68359L11.626 4.61133C11.7702 4.57331 11.8903 4.59567 11.9844 4.66699C12.0743 4.73539 12.1307 4.84141 12.168 4.95215C12.2422 5.17303 12.2526 5.45406 12.2627 5.62109L12.2637 5.62793H12.2627C12.1492 8.6215 7.85206 8.62198 7.73828 5.62793V5.62695Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.15"
      />
    </svg>
  );

};

export const svgIcons = {
  rocket: Rocket,
  user: User,
  delivery: Delivery,
  shop: Shop,
  reserve: Reserve,
  shopAdd: ShopAdd,
  note: Note,
  rocket2: Rocket2,
  eye: Eye,
  search: Search,
  arrowRight: ArrowRight,
  arrowLeft: ArrowLeft,
  arrowDown: ArrowDown,
  edit: Edit,
  trash: Trash,
  uploadDocument: UploadDocument,
  more: More,
  calendar: Calendar,
  facebook: Facebook,
  whatsapp: Whatsapp,
  insta: Insta,
  messenger: Messenger,
  yandex: Yandex,
  talabat: Talabat,
  handStars: HandStars,
  remove: Remove,
  customerSupport: CustomerSupport,
  copy: Copy,
  trashRed: TrashRed,
  tabletWifi: TabletWifi,
  announcement: Announcement,
  boundingBox: BoundingBox,
  checkList: CheckList,
  copyLink: CopyLink,
  dashboardBrowsing: DashboardBrowsing,
  file01: File01,
  frame: Frame,
  saleTag02: SaleTag02,
  setting01: Setting01,
  truckDelivery: TruckDelivery,
  user1: User1,
  shoppingCart: ShoppingCart,
  tableManagement:TableManagement
};

export default svgIcons;
